export const worldMap = [
  {
    name: "Enter",
    mesh: "Enter",
    description: "A glowing brain portal that leads into the Vibe Energy world.",
    synonyms: ["enter", "go inside", "brain portal", "start", "explore", "open"],
  },
  {
    name: "Vibe",
    mesh: "Vibe",
    description: "The central vibe sphere that controls energy and sound.",
    synonyms: ["flex", "show flex", "energy sphere", "start flex", "activate flex"],
  },
  {
    name: "Skills",
    mesh: "skills",
    description: "A rotating skills hologram showing talents and abilities.",
    synonyms: ["skills", "show skills", "my abilities", "talents", "resume"],
  },
  {
    name: "Discover",
    mesh: "Discover",
    description: "The discovery stage showing projects and creations.",
    synonyms: ["discover", "projects", "explore projects", "show creations"],
  },
  {
    name: "Back",
    mesh: "back",
    description: "Moves to the previous scene or exits the current view.",
    synonyms: ["back", "go back", "previous", "exit"],
  },
];
